"use client";
import React, { useState } from "react";
import { Button } from "@/components/Button";
import { RingLoader } from "react-spinners";
// import { useCreateUser } from "@/lib/hooks/user/useCreateUser";
import { SubmitHandler, useForm } from "react-hook-form";
import { useLocale, useTranslations } from "next-intl";
import { useCreateUser } from "@/lib/hooks/user/useCreateUser";
import { Modal, message, Typography } from "antd";
import Image from "next/image";

type FormValues = {
	email?: string;
	password?: string;
	confirmPassword?: string;
	onSubmit: (data?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
	locale?: string;
};

interface SignUpFormProps {
	setActive: any;
}

const SignUpForm = ({ setActive }: SignUpFormProps) => {
	const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
	} = useForm<FormValues>();

	const { createUser, loading } = useCreateUser();
	const locale = useLocale();
	const [showCoupon, setShowCoupon] = useState(false);
	const couponCode = "6701e208-e3fa-4603-9f7b-3f236e2ff098";
	const [autoRedirect, setAutoRedirect] = useState(true);

	const onSubmit: SubmitHandler<FormValues> = (data) => {
		data.locale = locale;
		createUser(data, reset, (success) => {
			if (success) {
				setShowCoupon(true);
				// 不立即重定向，等待用户关闭弹窗
				setAutoRedirect(true);
			} else {
				setActive(1); // 如果失败，直接切换到登录页
			}
		});
	};

	// 复制优惠码到剪贴板
	const copyToClipboard = () => {
		navigator.clipboard
			.writeText(couponCode)
			.then(() => {
				message.success("Coupon copied to clipboard");
				// 复制成功后2秒切换到登录页
				if (autoRedirect) {
					setTimeout(() => {
						setShowCoupon(false);
						setActive(1);
					}, 2000);
				}
			})
			.catch(() => {
				message.error("Failed to copy coupon");
			});
	};

	// 处理优惠码弹窗关闭
	const handleCouponClose = () => {
		setShowCoupon(false);
		if (autoRedirect) {
			setActive(1); // 只有在autoRedirect为true时才切换到登录页
		}
	};

	// 关闭自动重定向功能
	const disableAutoRedirect = () => {
		setAutoRedirect(false);
	};

	const t = useTranslations();

	return (
		<div>
			<div className=" mt-7">
				<form action="" onSubmit={handleSubmit(onSubmit)}>
					<input
						type="email"
						id="email"
						className={`mt-6 w-full rounded-lg border bg-white px-5 py-3  text-xl outline-none placeholder:text-lg ${
							errors.email ? "border-red-500" : "border-themeSecondary300"
						}`}
						placeholder={t("common.Email")}
						{...register("email", { required: true })}
					/>
					<input
						type="password"
						id="password"
						className={`mt-6 w-full rounded-lg border bg-white px-5 py-3  text-xl outline-none placeholder:text-lg ${
							errors.password ? "border-red-500" : "border-themeSecondary300"
						}`}
						placeholder={t("common.Password")}
						{...register("password", {
							required: true,
						})}
					/>
					<input
						type="password"
						id="confirmPassword"
						className={`mt-6 w-full rounded-lg border bg-white px-5 py-3  text-xl outline-none placeholder:text-lg ${
							errors.confirmPassword ? "border-red-500" : "border-themeSecondary300"
						}`}
						placeholder={t("message.abe0432e8d804e4cd748b0993c2626be5413")}
						{...register("confirmPassword", { required: true })}
					/>
					<Button
						className={`mt-6 flex w-full items-center justify-center gap-4 !rounded-lg border-[1px]  border-black !bg-black hover:!bg-white hover:!text-black ${
							loading ? "bg-themeSecondary800" : ""
						}`}
					>
						{loading && <RingLoader color="#fff" size={30} />}
						{loading ? t("message.7f9e518a7a1d1e4bc3e8990bed1d9be4d404") + "..." : t("common.Sign_Up")}
					</Button>
				</form>
			</div>

			{/* 注册成功优惠码弹窗 */}
			<Modal
				open={showCoupon}
				onCancel={handleCouponClose}
				footer={null}
				centered
				width={400}
				closable={true}
				maskClosable={false}
				styles={{
					body: {
						padding: "30px",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						background: "linear-gradient(to bottom, #f8f8f8, #ffffff)",
					},
				}}
			>
				<div className="flex flex-col items-center text-center">
					<Image src="/image/pop/logo.png" alt="STARY" width={150} height={75} className="mb-4" />
					<Typography.Title level={4} style={{ marginBottom: "20px", color: "#333" }}>
						Thank You For Registering!
					</Typography.Title>
					<Typography.Paragraph style={{ fontSize: "16px", marginBottom: "20px" }}>
						Your Exclusive Registration Discount Code:
					</Typography.Paragraph>
					<div
						style={{
							padding: "12px 20px",
							background: "#f4f4f4",
							border: "1px dashed #ccc",
							borderRadius: "8px",
							marginBottom: "20px",
							width: "100%",
							wordBreak: "break-all",
							fontFamily: "monospace",
							fontSize: "14px",
						}}
					>
						{couponCode}
					</div>
					<Button
						type="lg"
						onClick={copyToClipboard}
						className="flex h-[40px] w-full items-center justify-center !rounded-[20px] !bg-black !text-white"
					>
						Copy Code
					</Button>
				</div>
			</Modal>
		</div>
	);
};

export default SignUpForm;
